import { axios } from "../../utils/axios";
import { formatRangeString } from "../Recibos/handlers";

export const hitEndpointTableros = async (submittedData, fechas, setRender, setIsLoading, setError) => {
  let start = new Date(submittedData.fecha_ini);
  var end = new Date(submittedData.fecha_fin);
  if (start > end) {
    setError("fecha_ini", { type: "dateComparison", message: "La fecha de inicio no debe ser mayor que la fecha fin" });
    return;
  }
  switch (submittedData.endpoint) {
    case "cantidad_actas_por_fecha":
      cantidadActasPorFecha(submittedData, setRender, setIsLoading);
      break;
    case "cantidad_actas_pagas_por_fecha":
      cantidadActasPagasPorFecha(submittedData, setRender, setIsLoading);
      break;
    case "total_recaudacion":
      totalRecaudacion(submittedData, setRender, setIsLoading);
      break;
    case "cantidad_actas_vencidas":
      cantidadActasVencidas(submittedData, setRender, setIsLoading);
      break;
    /* case "vista_de_acta_especifico":
      vistaDeActaEspecifico();
      break; */
    default:
      break;
  }
};

const formatDateToYYYYDDMM = (date) => {
  return date.split("-").reverse().join("-");
};

export const cantidadActasPorFecha = async (submittedData, setRender, setIsLoading) => {
  setIsLoading(true);
  const result = await axios().post(submittedData.endpoint, submittedData);

  setRender(
    <div>
      <p className='fw-bold text-primary'>
        Cantidad de actas generadas {formatRangeString(submittedData.fecha_ini, submittedData.fecha_fin)}:{" "}
        {result.data.data?.cantidadActas}
      </p>
    </div>
  );

  setIsLoading(false);
  return;
};

export const cantidadActasPagasPorFecha = async (submittedData, setRender, setIsLoading) => {
  setIsLoading(true);
  const result = await axios().post(submittedData.endpoint, submittedData);

  setRender(
    <div>
      <p className='fw-bold text-primary'>
        Cantidad de actas pagas {formatRangeString(submittedData.fecha_ini, submittedData.fecha_fin)}:{" "}
        {result.data.data?.cantidadRecibos} por un total de ${result.data.data?.monto.toLocaleString()}
      </p>
    </div>
  );

  setIsLoading(false);
  return;
};

export const totalRecaudacion = async (submittedData, setRender, setIsLoading) => {
  setIsLoading(true);
  const result = await axios().get(submittedData.endpoint);

  setRender(
    <div>
      <p className='fw-bold text-primary'>Total Recaudacion: ${result.data.data?.toLocaleString()}</p>
    </div>
  );

  setIsLoading(false);
  return;
};

export const cantidadActasVencidas = async (submittedData, setRender, setIsLoading) => {
  setIsLoading(true);
  const result = await axios().get(submittedData.endpoint);

  setRender(
    <div>
      <p className='fw-bold text-primary'>
        Total actas vencidas (que ya no son de pago voluntario): {result.data.data}
      </p>
    </div>
  );

  setIsLoading(false);
  return;
};

/* export const vistaDeActaEspecifico = async () => {
  console.log("vista_de_acta_especifico");
};
 */
